<template>
  <page-main @back="() => (isShowLeave = true)">
    <template slot="nav">
      <div class="score-nav">
        <p>球员信息</p>
      </div>
    </template>
    <template slot="main">
      <div class="page-main">
        <div class="step-box">
          <el-steps
            :active="activeStep"
            finish-status="success"
            process-status="wait"
            simple
          >
            <el-step title="比赛信息"></el-step>
            <el-step title="球探信息"></el-step>
            <el-step title="球员信息"></el-step>
            <el-step title="五环评分"></el-step>
            <el-step title="主观评价"></el-step>
          </el-steps>
        </div>
        <div class="scroll-area">
          <template>
            <vue-scroll :ops="ops">
              <div class="scroll-wrapper">
                <el-form
                  class="form-dom"
                  ref="scoutinfoFormDom"
                  :model="scoutinfoForm"
                  :rules="scoutRules"
                  label-width="240px"
                >
                  <!-- 球员姓名 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="name"
                    label="球员姓名"
                  >
                    <el-select
                      v-model="scoutinfoForm.name"
                      @change="handlePlayerSelectChanged"
                      clearable
                      :disabled="canInputEdit"
                      class="yioks-input"
                      placeholder="球员姓名"
                    >
                      <el-option
                        v-for="item in playerList"
                        :key="item.key"
                        :label="item.label"
                        :value="item.content"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 出生年月 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="birthday"
                    label="出生年月"
                  >
                    <el-date-picker
                      v-model="scoutinfoForm.birthday"
                      class="yioks-input"
                      value-format="timestamp"
                      type="date"
                      disabled
                      placeholder="出生年月"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>

                  <!-- 所在队伍 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="team"
                    label="所在队伍"
                  >
                    <el-select
                      v-model.trim="scoutinfoForm.team"
                      class="yioks-input"
                      placeholder="所在队伍"
                    >
                      <el-option
                        v-for="item in vsList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 球衣号码 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="shirtNumber"
                    label="球衣号码"
                  >
                    <el-select
                      v-model.number.trim="scoutinfoForm.shirtNumber"
                      class="yioks-input"
                      allow-create
                      filterable
                      placeholder="球衣号码"
                    >
                      <el-option
                        v-for="(item, index) in mins99"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 球队主要阵型 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="teamFormation"
                    label="球队主要阵型"
                  >
                    <el-select
                      v-model.trim="scoutinfoForm.teamFormation"
                      allow-create
                      filterable
                      class="yioks-input"
                      placeholder="球队主要阵型"
                    >
                      <el-option
                        v-for="(item, index) in formationOfTeam"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 场上主要位置 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="position"
                    label="场上主要位置"
                  >
                    <el-select
                      v-model.trim="scoutinfoForm.position"
                      class="yioks-input"
                      placeholder="场上主要位置"
                    >
                      <el-option
                        v-for="(item, index) in mainPosition"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 惯用脚 -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="preferredFoot"
                    label="惯用脚"
                  >
                    <el-select
                      v-model.trim="scoutinfoForm.preferredFoot"
                      class="yioks-input"
                      placeholder="惯用脚"
                    >
                      <el-option label="左" value="左"></el-option>
                      <el-option label="右" value="右"></el-option>
                      <el-option label="左右均衡" value="左右均衡"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- 上场时间（分钟） -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="playTime"
                    label="上场时间（分钟）"
                  >
                    <el-select
                      v-model.trim="scoutinfoForm.playTime"
                      class="yioks-input"
                      allow-create
                      filterable
                      placeholder="上场时间（分钟）"
                    >
                      <el-option
                        v-for="(item, index) in mins150"
                        :key="index"
                        :label="item.key"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <!-- 主要表现情况（进球、助攻等） -->
                  <el-form-item
                    class="yioks-form-item"
                    prop="performance"
                    label="主要表现情况（进球、助攻等）"
                  >
                    <el-input
                      v-model.trim="scoutinfoForm.performance"
                      class="yioks-input"
                      type="textarea"
                      :rows="3"
                      placeholder="主要表现情况（进球、助攻等）"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </vue-scroll>
          </template>
        </div>
        <div class="btn-box">
          <el-button type="danger" class="mr-25" @click="tempSave">
            暂时保存</el-button
          >
          <el-button type="danger" class="mr-25" @click.native.prevent="goBack"
            >上一步</el-button
          >
          <el-button
            type="primary"
            @click.native.prevent="handleClick('scoutinfoFormDom')"
            >下一步</el-button
          >
           <yioks-tips
            :showTips="isShowLeave"
            tips="离开页面未提交数据将会丢失，确认离开？"
            @hideTips="handleLeave"
          ></yioks-tips>
        </div>
      </div>
    </template>
  </page-main>
</template>

<script>
import { formationOfTeam, mainPosition } from "@/assets/js/status";
import ops from "@/assets/js/vuescrollOption";
import { getPlayerList, getReportDetails, postPlayerInfo } from "@/api/scout";
import yioks_function from "@/assets/js/yioks";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import yioksStorage from "@/assets/js/yioksStorage";

export default {
  data() {
    return {
      isShowLeave: false,
      ops: ops(),
      formationOfTeam,
      mainPosition,
      activeStep: 3,
      scoutinfoForm: {
        name: "",
        birthday: "",
        team: "",
        shirtNumber: "",
        teamFormation: "",
        position: "",
        preferredFoot: "",
        playTime: "",
        performance: "",
      },
      scoutRules: {
        name: [requiredItem("球员", true)],
        birthday: [requiredItem("出生年月", true)],
        team: [requiredItem("所在队伍", true)],
        shirtNumber: [requiredItem("球衣号码", true)],
        teamFormation: [requiredItem("球队阵型", true)],
        position: [requiredItem("场上位置", true)],
        preferredFoot: [requiredItem("惯用脚", true)],
        playTime: [requiredItem("上场时间", true)],
        performance: [requiredItem("主要表现情况")],
      },
      playerList: [],
      vsList: [],
      choosedPlayerInfo: {},
      canInputEdit: false,
    };
  },

  computed: {
    pickerOptions() {
      const that = this;
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      };
    },

    mins150() {
      let arr = [],
        i = 1;
      while (i <= 150) {
        arr.push({
          key: i,
          value: i,
        });
        i++;
      }
      return arr;
    },
    mins99() {
      let arr = [],
        i = 1;
      while (i <= 99) {
        arr.push({
          key: i,
          value: i,
        });
        i++;
      }
      return arr;
    },
    reportId() {
      const { reportId } = this.$route.query;
      return reportId;
    },
    scoutName() {
      const { scoutName } = this.$route.query;
      return scoutName;
    },
    scoutId() {
      const { scoutId } = this.$route.query;
      const localScoutId = yioksStorage.getItem("scoutId");
      return scoutId || localScoutId;
    },
    competionId() {
      const { competionId } = this.$route.query;
      return competionId;
    },
    isEdit() {
      const { isEdit } = this.$route.query;
      return 1 === Number(isEdit);
    },
  },

  components: {
    "page-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
  },

  mounted() {
    this.loadReportInfo();
  },

  methods: {
    goBack() {
      this.$refs['scoutinfoFormDom'].validate((valid) => {
        if (valid) {
          let { name, birthday, ...rest } = this.scoutinfoForm;
          const submitData = {
            ...rest,
            id: Number(this.reportId),
          };
          postPlayerInfo(submitData)
            .then(({ data }) => {
              if (data.status !== 0) {
                this.$message.error(data.msg);
                return;
              }
              this.$router.push({
                path: "scout_info",
                query: {
                  ...this.$route.query,
                  competionId: this.competionId,
                  scoutId: this.scoutId,
                  scoutName: this.scoutName || "",
                  isEdit: 1,
                },
              });
            })
            .catch((err) => {
              console.error("err", err);
            });
        }
      });
    },

    // 点击 下一步
    handleClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { name, birthday, ...rest } = this.scoutinfoForm;
          const submitData = {
            ...rest,
            id: Number(this.reportId),
          };
          postPlayerInfo(submitData)
            .then(({ data }) => {
              if (data.status !== 0) {
                this.$message.error(data.msg);
                return;
              }
              let routeQuery = {
                backPath: this.$route.path,
                playerId: submitData.playerId,
                reportId: this.reportId,
                scoutId: this.scoutId,
                isEdit: 1,
              };
              this.$router.push({
                path: "five_rings",
                query: routeQuery,
              });
            })
            .catch((err) => {
              console.error("err", err);
            });
        }
      });
    },
    
    // 离开
    handleLeave(status, flag) {
      if (flag) {
        const scoutName = this.scoutName;
        this.$router.push({
          path: "list",
          query: {
            scoutName,
          },
        });
      }
      this.isShowLeave = false;
    },

    // 暂时保存
    tempSave() {
      let { name, birthday, ...rest } = this.scoutinfoForm;
      const submitData = {
        ...rest,
        id: Number(this.reportId),
      };
      postPlayerInfo(submitData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          let routeQuery = {
            backPath: this.$route.path,
            playerId: submitData.playerId,
            reportId: this.reportId,
            scoutId: this.scoutId,
          };
          if (this.isEdit) {
            routeQuery["isEdit"] = 1;
          }
          this.$router.push({
            path: "list",
            query: routeQuery,
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 通过报告id获取报告详情
    loadReportInfo() {
      const paramsData = {
        id: this.reportId,
      };
      getReportDetails(paramsData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { id: report_id, competitionId, vs } = data.result;
          this.loadPageList(competitionId, data.result);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 获取球员列表
    loadPageList(competionId, reportInfo) {
      const paramsData = { id: competionId };
      getPlayerList(paramsData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          let editPlayer = "";
          this.playerList = data.result.map((item) => {
            const obj = {
              label: item.player_name,
              key: item.id_number,
              content: JSON.stringify(item),
            };
            if (this.isEdit && reportInfo.player_name === item.player_name) {
              editPlayer = JSON.stringify(item);
            }
            return obj;
          });

          /* 编辑模式，设置初始值 */
          if (this.isEdit) {
            const birthDayStr = yioks_function.parseIdNumber(
              reportInfo.id_number,
              0
            );
            const mergeObj = {
              name: editPlayer,
              birthday: new Date(birthDayStr).getTime(),
              team: reportInfo.team,
              shirtNumber:
                reportInfo.shirtNumber === 0 ? "" : reportInfo.shirtNumber,
              teamFormation: reportInfo.teamFormation,
              position: reportInfo.position,
              preferredFoot: reportInfo.preferredFoot,
              playTime: reportInfo.playTime,
              performance: reportInfo.performance,
              playerId: reportInfo.playerId,
              competitionId: reportInfo.competitionId,
            };
            this.scoutinfoForm = Object.assign(
              {},
              this.scoutinfoForm,
              mergeObj
            );
            if (reportInfo.player_name) {
              this.canInputEdit = true;
            } else {
              this.canInputEdit = false;
            }
            if (reportInfo.vs) {
              this.vsList = JSON.parse(reportInfo.vs).map((item) => ({
                key: item,
                value: item,
                label: item,
              }));
            } else {
              this.vsList = [];
            }
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    // 选择球员信息
    handlePlayerSelectChanged(val) {
      let row = JSON.parse(val);
      this.choosedPlayerInfo = row;
      const { id_number, vs, player_id, competition_id } = row;
      const birthDayStr = yioks_function.parseIdNumber(id_number, 0);
      if (vs) {
        this.vsList = JSON.parse(vs).map((item) => ({
          key: item,
          value: item,
          label: item,
        }));
      } else {
        this.vsList = [];
      }
      const mergeObj = {
        birthday: new Date(birthDayStr).getTime(),
        playerId: player_id,
        competitionId: competition_id,
      };
      this.scoutinfoForm = Object.assign({}, this.scoutinfoForm, mergeObj);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
.score-nav
  font-size $font_size_big
  display flex
  align-items center
  line-height $font_size_big
  color $color_white
.page-main
  width 100%
  padding 10px 10px 25px 25px
  box-sizing border-box
  background-color $block_bg_color_base
.scroll-area
  height 485px
  .form-dom
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding-top 20px
    box-sizing border-box
  .yioks-form-item
    margin-right 180px
  .yioks-input
    width 300px
.btn-box
  width 100%
  height 60px
  display flex
  justify-content center
  align-items center
.mr-25
  margin-right 25px
</style>

<style lang="stylus">
@import '~@/assets/css/variable'
.step-box
  display flex
  width 100%
  .el-steps--simple
    background-color rgba(0, 0, 0, 0)
    width 100%
    padding 13px 4%
.form-dom
  .el-form-item__label
    color #fff !important
    font-size 16px
  .yioks-form-item-switch
    .el-switch__label
      color #fff
    // .el-switch__label--left
    // &.is-active
    // color $color_primary
    .el-switch__label--right
      &.is-active
        color $color_suc
</style>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>